import { EntrataSession } from 'auth/EntrataSession';
import axios from 'axios';

import { BASE_URL } from './URL';

export const ENTRATA_LOGIN_REQUIRED_MESSAGE = 'Please login to the Entrata application';

axios.defaults.timeout = 300000;

const apiClient = axios.create({ baseURL: BASE_URL, withCredentials: true });

apiClient.interceptors.request.use(
  (config: any) => {
    const { headers, params, data } = config;
    const contentType = data instanceof FormData ? {} : { 'content-type': 'application/json' };
    const authHeader = EntrataSession.token
      ? { Authorization: `Bearer ${EntrataSession.token}` }
      : {};
    return {
      ...config,
      withCredentials: true,
      headers: {
        ...contentType,
        ...authHeader,
        ...headers,
      },
      ...(!!params && { params }),
      ...(!!data && { data }),
    };
  },
  (error: any) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    if (error?.response?.status === 401) {
      return Promise.reject(new Error(ENTRATA_LOGIN_REQUIRED_MESSAGE));
    }

    // Handle 400 and other error status codes
    const errorMessage =
      error?.response?.data?.message || error?.message || 'Something went wrong.';
    return Promise.reject(new Error(errorMessage));
  },
);

const { get, post, patch, put, delete: destroy } = apiClient;

export { destroy, get, patch, post, put };
